var formClass = new Formulaire();
var form = {

	formLoadOptin: function () {

		// on charge l'event blur sur le champs mail pour afficher ou non le block d'optin		
		var emailInput = document.getElementById("Email");
		emailInput.addEventListener('blur', () => {
			formClass._afficherOptinNL(emailInput);
		});
	},


	// charger  les events blur sur le champs mail des formulaires contact agence et contact presse
	formLoadEventOptinAgence: function () {
		
		var formContactAgence = $("#formContactAgency");
		formContactAgence.find("#Contact_Coordonnees_Email").on('blur', function () {
			var emailInput = document.getElementById("Contact_Coordonnees_Email");
			formClass._afficherOptinNL(emailInput);
		});

		var formContactPresse = $("#formPresse");
		formContactPresse.find("#Presse_Coordonnees_Email").on('blur', function () {
			var emailInput = document.getElementById("Presse_Coordonnees_Email");
			formClass._afficherOptinNL(emailInput);
		});
	},
	formRemoveError: function () {
		$('.form').find('input, textarea').on('focus', function () {
			$(this).removeClass('parsley-error');
			$(this).next('ul').remove();
		});
	},

	captcha(callback, obj) {
		captchaModule.then((module) => {
			let captcha = new module();
			captcha.initialize(callback, obj);
		});
	},
	event: function () {
		
		let self = this,
			arrayFormsWithCaptcha = ['formContact', 'formContactAgency', 'formPresse']

		self.formLoadEventOptinAgence();

		obj = {
			'formContact': () => {
				
				self.formContact();
				const formContact = document.getElementById("formContact");
				formClass._saveOptinNL(formContact);
				
			},
			'formContactAgency': () => {
				self.formContactAgency();
				const formContactAgency = document.getElementById("formContactAgency");
				formClass._saveOptinNL(formContactAgency);
				
			},
			
			'formPresse': () => {
				
				self.formPresse();
				const formContactPresse = document.getElementById("formPresse");
				formClass._saveOptinNL(formContactPresse);
				
			},
		}
		document.body.addEventListener('submit', (e) => {
			e.preventDefault();

			if (arrayFormsWithCaptcha.includes(e.target.id)) {
				self.captcha(obj[e.target.id],{
					id: e.target.id
				})
			}
		})

		this.formRemoveError();
	},
	
	formContact: function () {

		var myForm = $('#formContact');
		var token = $('input[name="__RequestVerificationToken"]', myForm).val();
		

		if (myForm.parsley().isValid()) {
			
			var urlSetContact = agenceConfig.urlSetContact;

			let data = {
				__RequestVerificationToken: token,
				civilite: myForm.find("#Civilite").val(),
				nom: myForm.find("#Nom").val(),
				prenom: myForm.find("#Prenom").val(),
				adresse1: "",
				adresse2: "",
				adresse3: "",
				adresse4: "",
				codePostal: myForm.find("#CodePostal").val(),
				ville: myForm.find("#Ville").val(),
				pays: myForm.find("#Pays").val(),
				email: myForm.find("#Email").val(),
				telephonePortable: myForm.find("#TelMobile").val(),
				telephonePerso: "", //myForm.find("#TelFixe").val()
				codeIsoForMobile: myForm.find("#CodeIsoForMobile").val(),
				codeIsoForFixe: "", //myForm.find("#CodeIsoForFixe").val()
				sujet: "",
				message: myForm.find("#message").val(),
				to: "",
				listCheck: ""
			}

			$.ajax({
				url: urlSetContact,
				data: data,
				type: "POST",
				success: function (data) {
					myForm.find(".form__message_error").html('');
					myForm.find(".form__message_success").html(data.Message);
					setTimeout(function () {
						$('#modalContact').find('.modal').removeClass('modal_open');
						$('html').css('overflow', 'auto');
					}, 3000);

				},
				error: function (data) {
					myForm.find(".form__message_success").html('');
					myForm.find(".form__message_error").html(data.MessageError);
				}
			});
		}
	},

	formContactAgency: function () {

		var myForm = $('#formContactAgency');

		var myData = {
			urlForm: myForm.attr('data-url-action'),
			civilite: myForm.find("#Civilite"),
			nom: myForm.find("#Contact_Coordonnees_Nom"),
			prenom: myForm.find("#Contact_Coordonnees_Prenom"),
			email: myForm.find("#Contact_Coordonnees_Email"),
			phone: myForm.find("#Contact_Coordonnees_Phone"),
			message: myForm.find("#Contact_Coordonnees_Message"),
			idAgence: parseInt(agenceConfig.idAgence)
		};

		var token = $('input[name="__RequestVerificationToken"]', myForm).val();

		if (myForm.parsley().isValid()) {

			$.ajax({
				url: myData.urlForm,
				dataType: 'json',
				type: "POST",
				data: {
					__RequestVerificationToken: token,
					civilite: myData.civilite.val(),
					nom: myData.nom.val(),
					prenom: myData.prenom.val(),
					email: myData.email.val(),
					phone: myData.phone.val(),
					message: myData.message.val(),
					idAgence: myData.idAgence
				},
				success: function (data) {
					myForm.find(".form__message_error").html('');
					myForm.find(".form__message_success").html(data.Message);
				},
				error: function (data) {
					myForm.find(".form__message_success").html('');
					myForm.find(".form__message_error").html(data.MessageError);
				},
				complete: function (data) {
					setTimeout(function () {
						$('.form__message').html('');
					}, 3000);
				}
			});

		}
	},

	formPresse: function () {

		var myForm = $('#formPresse');

		var myData = {
			urlForm: myForm.attr('data-url-contact'),
			civilite: myForm.find("#Presse_Coordonnees_Civilite > option:selected"),
			nom: myForm.find('#Presse_Coordonnees_Nom'),
			prenom: myForm.find('#Presse_Coordonnees_Prenom'),
			email: myForm.find('#Presse_Coordonnees_Email'),
			telephonePro: myForm.find('#Presse_Coordonnees_TelephonePro'),
			sujet: myForm.find('#Presse_Coordonnees_Sujet'),
			message: myForm.find('#Presse_Coordonnees_Message'),
			contactPress: document.getElementById('contactPress')
		};

		var token = $('input[name="__RequestVerificationToken"]', myForm).val();

		if (myForm.parsley().isValid()) {

			let data = {
				__RequestVerificationToken: token,
				civilite: myData.civilite.val(),
				nom: myData.nom.val(),
				prenom: myData.prenom.val(),
				email: myData.email.val(),
				telephonePro: myData.telephonePro.val(),
				sujet: myData.sujet.val(),
				message: myData.message.val(),
				contactPress: myData.contactPress.value,
			}

			$.ajax({
				url: myData.urlForm,
				data: data,
				type: "POST",
				success: function (data) {
					myForm.find(".form__message_error").html('');
					myForm.find(".form__message_success").html(data.Message);
					setTimeout(function () {
						$('#modalPresse').removeClass('modal_open');
						$('html').css('overflow', 'auto');
					}, 3000);

				},
				error: function (data) {
					myForm.find(".form__message_success").html('');
					myForm.find(".form__message_error").html(data.MessageError);
				}
			});

		}
	},

	visuVille: function (RtnData) {
		var _listeVilleChoix = [];
		var repville = eval('(' + RtnData + ')');

		var pos = 1;
		while (true) {
			try {
				_listeVilleChoix.push({
					label: repville[pos].Localite + ' ' + repville[pos].LieuDit,
					value: repville[pos].Localite,
					id: pos,
					codeville: repville[pos].IDLocalite,
					ville: repville[pos].Localite,
					lieudit: repville[pos].LieuDit,
					codePostal: repville[pos].CodePostal
				});
				pos += 1;
			} catch (err) {

				break;
			}
		}

		pos -= 1;
		$('form').find('.Ville').focus();
		if (pos > 1) {

			$('form').find('.Ville').autocomplete({
				options: {
					delay: 1,
					minLength: 3
				},
				source: _listeVilleChoix

			}).autocomplete("search", " ");
		} else {
			if (pos == 1) {
				$('form').find('.Ville').val(_listeVilleChoix[0]['ville']);
			}
		}

	},

	valideCP: function (myForm) {
		var regexCp = /[0-9{4,5}]/; //regex FRA, BEL, CHE
		var pays = myForm.find(".Pays").val();

		if ((pays == "FRA" || pays == "BEL" || pays == "CHE") && !regexCp.test(myForm.find(".CodePostal").val())) {
			return false;
		}
		return true;
	},

	afficheVille: function () {
		var _licence = 'TERDAV';
		var _instance = 0;
		var _urldqe = 'https://prod3.dqe-software.com/'

		var myForm = $(this).closest('form');

		if (form.valideCP(myForm)) {
			$.ajax({
				url: _urldqe + "CP/",
				dataType: "jsonp",
				cache: false,
				data: {
					Pays: myForm.find(".Pays").val(),
					CodePostal: myForm.find(".CodePostal").val(),
					Licence: _licence,
					Instance: _instance,
					Alpha: false
				},
				jsonp: "callback",
				crossDomain: true,
				success: form.visuVille
			});
		}
	},

	init: function () {
		form.event();
	}
};

function verifMail(champ) {
	var regex = /^[a-zA-Z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,4}$/;

	if (!regex.test(champ)) {
		return false;
	} else {
		return true;
	}
}


